import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// Pinia config
import { createPinia } from "pinia";

// Emitter config 
import mitt from "mitt";
const Emitter = mitt();
// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "@mdi/font/css/materialdesignicons.css";

import VueCookies from 'vue-cookies'

// import { VDatePicker } from 'vuetify/labs/VPicker'

// export default createVuetify({
//   components: {
//     VDatePicker,
//   },
// })

// components.VDatePicker =VDatePicker;

// [matrah] legacy:
// const vuetify = createVuetify({
//   components: {
//     ...components,
//         // VDatePicker,
//       },
//   directives,
// });

// [matrah] Committee brand theme: deep green (primary) + gold (secondary),
// picked from the Zakat Matrah logo. Views reference these tokens instead of
// hard-coded hex values so the palette can be tuned from one place.
const matrahTheme = {
  dark: false,
  colors: {
    primary: "#1B6B3F",
    "primary-darken-1": "#12502E",
    "primary-lighten-1": "#E7F1EB",
    secondary: "#C9A227",
    "secondary-darken-1": "#9E7D14",
    "secondary-lighten-1": "#FBF4DF",
    accent: "#C9A227",
    background: "#F6F8F6",
    surface: "#FFFFFF",
    "surface-light": "#F1F4F1",
    success: "#2E7D32",
    info: "#1E6FA8",
    warning: "#E0A100",
    error: "#C62828",
    whatsapp: "#25D366",
  },
};

const vuetify = createVuetify({
  components: {
    ...components,
    // VDatePicker,
  },
  directives,
  theme: {
    defaultTheme: "matrah",
    themes: {
      matrah: matrahTheme,
    },
  },
});

createApp(App).use(VueCookies).use(vuetify).provide('Emitter', Emitter).use(createPinia()).use(router).mount("#app");
